import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const OverbygningPilNed: React.FC<SvgProps> = ({ pathFill = '#077197', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 104 40'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				id='Vector 103'
				d='M101 40L103.541 34.8156L97.7807 35.2075L101 40ZM0.500244 0C0.500244 5.61569 1.37533 9.89459 3.26532 13.1358C5.16397 16.3918 8.05478 18.5464 11.9707 19.9699C15.8719 21.3881 20.8081 22.0876 26.8341 22.4367C32.8639 22.7859 40.0268 22.7857 48.3915 22.7857V21.7857C40.0172 21.7857 32.8866 21.7855 26.8919 21.4383C20.8935 21.0909 16.0743 20.3976 12.3124 19.0301C8.56528 17.6679 5.88543 15.6439 4.12919 12.6321C2.36429 9.60541 1.50024 5.52717 1.50024 0H0.500244ZM48.3915 22.7857C55.6833 22.7857 62.4386 22.4721 68.486 22.2878C74.5444 22.103 79.8855 22.0483 84.394 22.5571C88.9053 23.0663 92.5231 24.1343 95.1733 26.149C97.8049 28.1494 99.5384 31.1267 100.2 35.5816L101.189 35.4347C100.497 30.7741 98.6566 27.5408 95.7785 25.3529C92.919 23.1792 89.0914 22.081 84.5062 21.5635C79.9182 21.0456 74.5115 21.1036 68.4555 21.2882C62.3885 21.4732 55.6629 21.7857 48.3915 21.7857V22.7857Z'
				fill={pathFill}
			/>
		</svg>
	);
};
